export const solicitationData = [
	{
		sectionName: 'Section C: Statement of Work',
		question:
			'Describe your customer and their priorities and the “why” or background of the problem you are trying to solve for them',
		infoText: `This question requires an understanding of the agency or department you are proposing to, including their mission, goals, and current challenges. Research the customer to identify their values, strategic objectives, and any pressing issues they face. It's not just about stating who the customer is but demonstrating a deep understanding of what drives them.
        Key Points to Cover:
        - Customer's mission and strategic objectives.
        - Current challenges and pain points the customer is facing.`,
	},
	{
		sectionName: 'Section C: Statement of Work',
		question: 'What problems have you identified that your project may solve',
		infoText: `This question asks you to articulate the specific challenges or issues your solution addresses. Use data and evidence to define the problem clearly. It's important to link the problem directly to the customer's priorities and objectives, demonstrating a direct impact on their mission or operations.
        Key Points to Cover:
        - Specific problems or challenges identified.
        - Evidence or data supporting the existence of these problems.`,
	},
	{
		sectionName: 'Section M: Evaluation Criteria',
		question:
			'Who are the people the project will impact and where are they located ?',
		infoText: `Here, you need to identify the direct and indirect users or beneficiaries of your project, including any specific groups or communities. Discuss the geographic location of these beneficiaries and any relevant demographic information. This question often seeks to understand the scope of impact and ensures that the proposal considers the human element of the solution.
        Key Points to Cover:
        - Direct and indirect end users or beneficiaries of the project.
        - Geographic location of impacted individuals or communities.
        - Demographic information of the target groups, if relevant.`,
	},
	{
		sectionName: 'Section M: Evaluation Criteria',
		question: 'Who are the key stakeholders that you would be engaging with?',
		infoText: `This question requires you to identify stakeholders relevant to the project's success, including potential partners, government entities, community organizations, or other relevant groups. Describe the role of each key player and their importance to the project.
        Key Points to Cover:
        - Identification of key stakeholders and partners.
        - The role and importance of each stakeholder in the project.`,
	},
	{
		sectionName: 'Section M: Evaluation Criteria',
		question:
			'Are there key activities or benchmarks your customer or funder require from you?',
		infoText: `Answering this question involves outlining the specific deliverables, milestones, or performance benchmarks set forth or implied by the funder. It's critical to demonstrate your understanding of the funder's expectations. This may include timelines, reporting mechanisms, and any specific outcomes that are expected.
        Key Points to Cover:
        - Specific deliverables or milestones required by the funder.`,
	},
	{
		sectionName: 'Section M: Evaluation Criteria',
		question: 'How does your customer measure success?',
		infoText: `This question focuses on understanding the metrics, benchmarks, and/or objective standards the customer uses to evaluate the effectiveness of their operations or the success of their projects. It's important to identify these measures of success to tailor your proposal to demonstrate how your solution can achieve or exceed these benchmarks.
        Key Points to Cover:
        - Specific performance indicators, metrics, or outcomes the customer uses to measure success.
        - How your solution can contribute to achieving these metrics, including any data or evidence that supports your claims.
        - Any additional benefits your solution offers that align with the customer's broader strategic goals or performance measures.`,
	},
	{
		sectionName: 'Section M: Evaluation Criteria',
		question:
			'Do you know if the customer has a timeline? If so, can you provide when they want the full or parts of their problem solved?',
		infoText: `This question assesses your understanding of the customer’s urgency and scheduling requirements for the solution. Addressing this demonstrates your proposal’s responsiveness to the customer’s needs and your ability to deliver within their desired timeframe.
        Key Points to Cover:
        - Any specific deadlines, milestones, or timelines mentioned in the solicitation documents or discovered through market research.
        - A detailed plan showing how your proposed solution aligns with the customer's timeline, including any phases or interim deliverables.
        - Flexibility in your approach to accommodate any potential changes in the customer’s timeline or priorities.`,
	},
];
